import React from 'react';
import { modules } from '../data/modules';
export function Modules() {
  return <section className="bg-white px-4 py-4" data-id="element-106" data-mp="1r63rh4h50cko">
      <div className="mx-auto max-w-3xl" data-id="element-107" data-mp="1r50zsubzq63p">
        <h2 className="mb-2.5 text-center font-display text-[21px] leading-tight text-ev-black sm:text-3xl" data-id="element-108" data-mp="1vx2a4apllmr3">
          What&apos;s Included
        </h2>
        <ul className="space-y-2" data-id="element-109" data-mp="20uu3za9szixx">
          {modules.map(module => <li key={module.number} data-id="element-110" data-mp="146o22v49n4nc">
              <article className="overflow-hidden rounded-lg border border-ev-line bg-ev-paper" style={{
            borderLeft: `6px solid ${module.color}`
          }} data-id="element-111" data-mp="147peb2x0px6n">
                <div className="p-3" data-id="element-112" data-mp="1d4zsox54u2fs">
                  <h3 className="mb-1 font-cond text-[17px] leading-snug tracking-wide sm:text-xl" data-id="element-113" data-mp="1i5nnzv0e95ft">
                    <span className="mr-1 text-ev-black" data-id="element-114" data-mp="2olzssexq1lkd">✅ Module {module.number} —</span>
                    <span style={{
                  color: module.color
                }} data-id="element-115" data-mp="2tku8v94b0w0s">{module.title}</span>
                  </h3>
                  <p className="text-[13px] font-medium leading-snug text-ev-black/75 sm:text-[15px]" data-id="element-116" data-mp="1v2w5h5vhq24">
                    {module.body}
                  </p>
                  <p className="mt-1 font-cond text-[14px] uppercase tracking-wide text-ev-black sm:text-base" data-id="element-117" data-mp="3tzdk24lceox1">
                    {module.tagline}
                  </p>
                </div>
              </article>
            </li>)}
        </ul>
      </div>
    </section>;
}